import { api } from '../apiSlice';

export const formApi = api
  .injectEndpoints({
    endpoints: build => ({

      submitServicesForm: build.mutation({
        query: (params) => ({
          url: '/forms/services',
          method: 'POST',
          body: params,
        }),
      }),

    }),
  });

export const {
  useSubmitServicesFormMutation,
} = formApi;
